export default "__VITE_ASSET__bf4d4dfc__"